"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = save;

var _element = require("@wordpress/element");

/**
 * WordPress dependencies
 */
function save() {
  return (0, _element.createElement)(_element.RawHTML, null, '<!--nextpage-->');
}
//# sourceMappingURL=save.js.map